<div class="w-full">
  <section class="grid grid-cols-12 gap-6">
    <!-- Mobile Toolbar -->
    <div class="col-span-12 sm:hidden">
      <div class="grid grid-cols-12 gap-3 rounded-2xl border border-gray-300 bg-white/95 p-3 backdrop-blur">
        <div class="col-span-5">
          <button
            class="primary-btn h-[50px] w-full whitespace-nowrap rounded-xl border border-gray-300 px-4 text-sm font-semibold shadow-none transition hover:shadow-none"
            (click)="createNewPost()">
            Create New Post
        </button>
        </div>

        <div class="col-span-7">
          <div class="flex h-[50px] w-full items-center rounded-xl border border-gray-300 bg-gray-50 px-3 transition focus-within:border-gray-300 focus-within:bg-white">
            <mat-icon class="flex-shrink-0 text-gray-400">search</mat-icon>

            <input
              #searchInputMobile
              type="text"
              placeholder="Search..."
              [(ngModel)]="searchValue"
              (keyup.enter)="submitSearch(searchInputMobile.value)"
              (input)="searchValue = searchInputMobile.value"
              class="min-w-0 flex-grow bg-transparent px-2 text-sm text-gray-700 outline-none placeholder-gray-400"
            />

            <button
              type="button"
              (click)="searchInputMobile.value=''; searchValue=''; submitSearch('')"
              [class.opacity-0]="!searchValue"
              [class.pointer-events-none]="!searchValue"
              class="ml-1 flex flex-shrink-0 items-center justify-center rounded-full p-1.5 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700"
            >
              <mat-icon class="cursor-pointer text-lg">close</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Paginator -->
    <div class="col-span-12 sm:hidden">
      <div class="flex items-center justify-end rounded-2xl border border-gray-300 bg-white px-2 py-1">
        <mat-paginator
          [length]="totalItems"
          [pageSize]="pageSize"
          [pageSizeOptions]="[pageSize]"
          showFirstLastButtons
          (page)="onPageChange($event)"
        >
        </mat-paginator>
      </div>
    </div>

    <!-- Desktop Toolbar -->
    <div class="col-span-12 hidden sm:block">
      <div class="grid grid-cols-12 items-center gap-4 rounded-2xl border border-gray-300 bg-white/95 p-4 backdrop-blur">
        <div class="col-span-12 md:col-span-3 lg:col-span-3">
          <button
            class="primary-btn h-[50px] rounded-xl px-5 text-sm font-semibold transition"
            (click)="createNewPost()"
          >
            Create New Post
          </button>
        </div>

        <div class="col-span-12 md:col-span-9 lg:col-span-9">
          <div class="flex items-center justify-end gap-3">
            <div class="flex w-full justify-center">
              <div class="flex h-[50px] w-full max-w-md items-center rounded-xl border border-gray-300 bg-gray-50 px-3 transition focus-within:border-gray-300 focus-within:bg-white">

                <mat-icon class="flex-shrink-0 text-gray-400">
                  search
                </mat-icon>

                <input
                  #searchInput
                  type="text"
                  placeholder="Search..."
                  [(ngModel)]="searchValue"
                  (keyup.enter)="submitSearch(searchInput.value)"
                  (input)="searchValue = searchInput.value"
                  class="min-w-0 flex-grow bg-transparent px-2 text-sm text-gray-700 outline-none placeholder-gray-400"
                />

                <button
                  type="button"
                  (click)="searchInput.value=''; searchValue=''; submitSearch('')"
                  [class.opacity-0]="!searchValue"
                  [class.pointer-events-none]="!searchValue"
                  class="ml-1 flex flex-shrink-0 items-center justify-center rounded-full p-1.5 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700"
                >
                  <mat-icon class="cursor-pointer text-lg">
                    close
                  </mat-icon>
                </button>

              </div>
            </div>

            <div class="flex shrink-0 items-center items-center rounded-xl border border-gray-100">
              <mat-paginator
                [length]="totalItems"
                [pageSize]="pageSize"
                [pageSizeOptions]="[pageSize]"
                showFirstLastButtons
                (page)="onPageChange($event)"
              >
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Posts Grid -->
    <ng-container *ngIf="!isLoading && !errorMsg">
      <ng-container *ngIf="posts.length; else noData">
        <article
          *ngFor="let p of posts; trackBy: trackById"
          class="group col-span-12 flex h-full flex-col overflow-hidden rounded-2xl border border-gray-300 bg-white transition duration-200 hover:-translate-y-0.5 hover:border-gray-300 sm:col-span-6 lg:col-span-4 xl:col-span-3"
        >
          <!-- Image -->
          <div class="relative aspect-video cursor-pointer overflow-hidden bg-gray-100">
            <img
              class="h-full w-full object-cover transition duration-300"
              [src]="getPostImageSrc(p)"
              (click)="viewRow(p)"
              (error)="onMainImgError($event,p)"
              alt=""
            />

            <div class="absolute inset-x-0 bottom-0 h-px bg-gray-300"></div>

            <div *ngIf="domainSlug(p.domain_name) as slug" class="absolute left-3 top-3">
              <div class="h-10 w-10 overflow-hidden rounded-full border-2 border-white bg-white ring-1 ring-black/5">
                <img
                  class="h-full w-full object-cover"
                  [src]="p.thumbnail_file_path"
                  [alt]="(p.domain_name || 'Company') + ' logo'"
                />
              </div>
            </div>

            <!-- Corner Ribbon -->
            <div
              *ngIf="isScheduledForToday(p.scheduled_for)"
              class="pointer-events-none absolute inset-0 z-10 select-none"
              aria-label="New: scheduled for today"
              matTooltip="Scheduled for today"
            >
              <div class="absolute right-0 top-0 h-16 w-16 bg-emerald-600 [clip-path:polygon(100%_0,0_0,100%_100%)]"></div>

              <div class="absolute top-1 -right-8 rotate-45">
                <span class="block whitespace-nowrap bg-emerald-600 px-10 py-2 text-center text-[12px] font-semibold uppercase tracking-wide text-white">
                  New
                </span>
              </div>
            </div>
          </div>

          <!-- Content -->
          <div class="flex flex-1 flex-col p-4">
            <!-- Meta -->
            <div class="flex flex-wrap items-center gap-2 text-xs text-gray-600">
              <div class="flex w-full items-center gap-2 rounded-xl border border-gray-300 px-3 py-2">
                <p class="inline text-[10px] font-semibold uppercase tracking-wide text-gray-400">
                  Domain:
                </p>

                <span class="min-w-0 flex-1 truncate text-[14px] font-medium text-gray-700">
                  {{ p.domain_name || '—' }}
                </span>

                <span
                  class="ml-auto inline-block h-3 w-3 flex-shrink-0 rounded-full ring-4 ring-white"
                  [ngClass]="{
                    'bg-green-500': p.post_status === 'PostedOnFacebook' || p.post_status === 'PostedOnInstagram' || p.post_status === 'PostedOnTikTok',
                    'bg-red-500': p.post_status === 'Fail' || p.post_status === 'Permanently Failed',
                    'bg-gray-400': p.post_status !== 'Fail' && p.post_status !== 'Permanently Failed' && p.post_status !== 'PostedOnFacebook' && p.post_status !== 'PostedOnInstagram' && p.post_status !== 'PostedOnTikTok'
                  }"
                  [matTooltip]="
                    p.post_status === 'Fail' || p.post_status === 'Permanently Failed' ? 'Failed' :
                    (p.post_status === 'PostedOnFacebook' || p.post_status === 'PostedOnInstagram' || p.post_status === 'PostedOnTikTok' ? 'Published' : 'Pending')
                  "
                ></span>
              </div>

              <ng-container *ngIf="p.social_platform_title as plat">
                <span class="inline-flex max-w-full items-center gap-1 rounded-full border border-gray-300 bg-white px-2.5 py-1 text-[11px] font-medium">
                  <span class="min-w-0 truncate" [ngClass]="platformTextClass(plat)">
                    {{ plat }}
                  </span>
                </span>
              </ng-container>

              <ng-container *ngIf="p.tag">
                <span class="inline-flex max-w-full items-center gap-1 rounded-full border border-emerald-100 bg-emerald-50 px-2.5 py-1 text-[11px] font-medium text-emerald-700">
                  <span class="truncate">#{{ p.tag }}</span>
                </span>
              </ng-container>
            </div>

            <!-- Schedule Date -->
            <div
              class="mb-2 mt-3 flex min-h-[22px] items-center gap-1.5 rounded-lg"
              [class.opacity-0]="!(p.scheduled_for &&
                (p.post_status === 'PostedOnFacebook' ||
                p.post_status === 'PostedOnInstagram' ||
                p.post_status === 'PostedOnTikTok'))"
            >
              <svg
                class="h-3.5 w-3.5 flex-shrink-0 text-gray-400"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                viewBox="0 0 24 24"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>

              <span class="text-[11px] font-medium text-gray-400">
                {{ (p.scheduled_for &&
                    (p.post_status === 'PostedOnFacebook' ||
                    p.post_status === 'PostedOnInstagram' ||
                    p.post_status === 'PostedOnTikTok'))
                    ? (p.scheduled_for | date:'d MMM y, HH:mm')
                    : '\u00A0' }}
              </span>
            </div>

            <!-- Title -->
            <div
              role="heading"
              aria-level="3"
              class="h-[4.125rem] text-[15px] font-semibold leading-snug text-gray-900 line-clamp-3"
              [attr.dir]="p.text_direction || 'ltr'"
            >
              {{ p.rss_title }}
            </div>

            <!-- Description -->
            <div
              class="mt-3 flex min-h-[3.25rem] items-start rounded-r-xl border-l-2 border-gray-300 bg-gray-50/80 py-2 pl-3 pr-2"
              [attr.dir]="p.text_direction || 'ltr'"
            >
              <p class="break-words text-[13px] leading-relaxed text-gray-600 line-clamp-2">
                {{ p.rss_description }}
              </p>
            </div>

            <!-- Actions -->
            <div class="mt-auto pt-4">
              <div class="flex flex-wrap items-center justify-center gap-1.5 border-t border-gray-300 pt-3 sm:flex-nowrap sm:justify-end md:gap-2">
                <!-- Edit -->
                <button
                  class="manage-post-btn"
                  mat-icon-button
                  color="primary"
                  (click)="editRow(p)"
                  [disabled]="['PostedOnInstagram','PostedOnFacebook'].includes(p.post_status || '') || p.enable_repeat === -1"
                  matTooltip="Edit"
                  aria-label="Edit"
                >
                  <mat-icon>edit</mat-icon>
                </button>

                <!-- Reuse -->
                <button
                  class="manage-post-btn"
                  mat-icon-button
                  color="primary"
                  (click)="reuseRow(p)"
                  [disabled]="['Draft','Fail','Permanently Failed'].includes(p.post_status || '')"
                  matTooltip="Reuse"
                  aria-label="Reuse"
                >
                  <mat-icon>replay</mat-icon>
                </button>

                <!-- Preview -->
                <button
                  class="manage-post-btn"
                  mat-icon-button
                  color="accent"
                  (click)="viewRow(p)"
                  matTooltip="Preview"
                  aria-label="Preview"
                >
                  <mat-icon>search</mat-icon>
                </button>

                <!-- Repeat -->
                <button
                  class="manage-post-btn"
                  mat-icon-button
                  color="accent"
                  (click)="repeatPostRow(p)"
                  matTooltip="Repeat"
                  aria-label="Repeat"
                >
                  <mat-icon>repeat</mat-icon>
                </button>

                <!-- Delete -->
                <button
                  class="manage-post-btn"
                  mat-icon-button
                  (click)="openDeleteConfirm(p)"
                  [disabled]="(p.post_status || '') === 'PostedOnFacebook' || (p.post_status || '') === 'PostedOnInstagram' || (p.post_status || '') === 'PostedOnTikTok'"
                  matTooltip="Delete"
                  aria-label="Delete"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </article>
      </ng-container>
    </ng-container>

    <!-- Empty State -->
    <ng-template #noData>
      <div class="col-span-12 rounded-2xl border border-dashed border-gray-300 bg-white px-6 py-12 text-center">
        <div class="mx-auto flex max-w-sm flex-col items-center gap-2">
          <div class="flex h-12 w-12 items-center justify-center rounded-full bg-gray-50 text-gray-400">
            <mat-icon>inbox</mat-icon>
          </div>

          <p class="text-sm font-semibold text-gray-800">
            No posts found.
          </p>
        </div>
      </div>
    </ng-template>

    <!-- Bottom Paginator -->
    <div class="col-span-12 border border-gray-300 rounded-2xl">
      <div class="flex items-center justify-end gap-2 rounded-2xl bg-white px-3 py-2">
        <div  div class="w-fit overflow-hidden rounded-xl bg-white">
          <mat-paginator
          [length]="totalItems"
          [pageSize]="pageSize"
          [pageSizeOptions]="[pageSize]"
          showFirstLastButtons
          (page)="onPageChange($event)"
        >
        </mat-paginator>
        </div>
    </div>
    </div>
  </section>
</div>